import React from 'react';
import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';

class SmsList extends React.Component {
  render() {
    return (
        <>
            <div className="sectionlist pt-3">
                <div className="container-fluid">
                    <div className="row">
                    <div className="col-md-6 pb-3">
                            <h3>SMS Templatess</h3>
                        </div>
                        <div className="col-md-6 text-right pb-3">
                            <Link type="button" to="/sms-add" class="buttons success">+ Add SMS Template</Link>
                        </div>
                        <div className="col-md-12">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>View</th>
                                    <th>Created By</th>
                                    <th>Created Date</th>
                                    <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td>1</td>
                                    <td>John</td>
                                    <td><Link to="/#"> View 1 </Link></td>
                                    <td>Shubham</td>
                                    <td>14/06/2021 09:14pm</td>
                                    <td><Link to="#" className="buttons update"><FaPencilAlt /> Update</Link>   <Link to="#" className="buttons delete"><FaTrash /> Delete</Link></td>
                                    </tr>

                                    <tr>
                                    <td>2</td>
                                    <td>Kon</td>
                                    <td><Link to=""> View 2</Link></td>
                                    <td>Shubham</td>
                                    <td>14/06/2021 09:14pm</td>
                                    <td><Link to="#" className="buttons update"><FaPencilAlt /> Update</Link>   <Link to="#" className="buttons delete"><FaTrash /> Delete</Link></td>
                                    </tr>

                                    <tr>
                                    <td>3</td>
                                    <td>Ainn</td>
                                    <td><Link to=""> View 3</Link></td>
                                    <td>Shubham</td>
                                    <td>14/06/2021 09:14pm</td>
                                    <td><Link to="#" className="buttons update"><FaPencilAlt /> Update</Link>   <Link to="#" className="buttons delete"><FaTrash /> Delete</Link></td>
                                    </tr>

                                    <tr>
                                    <td>4</td>
                                    <td>Jass</td>
                                    <td><Link to=""> View 4</Link></td>
                                    <td>Shubham</td>
                                    <td>14/06/2021 09:14pm</td>
                                    <td><Link to="#" className="buttons update"><FaPencilAlt /> Update</Link>   <Link to="#" className="buttons delete"><FaTrash /> Delete</Link></td>
                                    </tr>

                                    <tr>
                                    <td>5</td>
                                    <td>Shubham</td>
                                    <td><Link to=""> View 5</Link></td>
                                    <td>Shubham</td>
                                    <td>14/06/2021 09:14pm</td>
                                    <td><Link to="#" className="buttons update"><FaPencilAlt /> Update</Link>   <Link to="#" className="buttons delete"><FaTrash /> Delete</Link></td>
                                    </tr>
                                    
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
  }
}
export default SmsList;
